import { useChainId } from 'wagmi';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { clearError, ErrorButtonType, setError } from "../../state/errorSlice";
import { ETH_GLOBALS, GlobalsType, GOERLI_GLOBALS } from "../globals";

const useGlobals = (): GlobalsType => {
  const dispatch = useDispatch();
  const chainId = useChainId();

  useEffect(() => {
    if (chainId === 5 || chainId === 1 || !chainId) {
      dispatch(clearError());
    } else {
      dispatch(
        setError({
          header: "Unsupported network",
          subHeader: "Only Goerli and Mainnet are supported",
          button: ErrorButtonType.SWITCH_TO_MAINNET,
        })
      );
    }
  }, [chainId, dispatch]);

  if (chainId === 5) {
    return GOERLI_GLOBALS;
  }
  if (chainId === 1) {
    return ETH_GLOBALS;
  }
  return ETH_GLOBALS;
};

export default useGlobals;
